import { NavLink, Outlet } from 'react-router-dom';
import { UserCircle, Users, KeyRound, Code2, MessagesSquare, Tag } from 'lucide-react';
import { useAuthStore } from '../../lib/auth-store';

const TABS = [
  { to: '/admin/settings/profile', label: 'Mi perfil', icon: UserCircle, allow: null },
  {
    to: '/admin/settings/users',
    label: 'Usuarios',
    icon: Users,
    allow: ['admin', 'supervisor'] as const,
  },
  {
    to: '/admin/settings/api-keys',
    label: 'API Keys',
    icon: KeyRound,
    allow: ['admin'] as const,
  },
  {
    to: '/admin/settings/integrations',
    label: 'Integraciones',
    icon: Code2,
    allow: ['admin'] as const,
  },
  {
    to: '/admin/settings/whatsapp',
    label: 'WhatsApp',
    icon: MessagesSquare,
    allow: ['admin', 'supervisor'] as const,
  },
  {
    to: '/admin/settings/categories',
    label: 'Categorías',
    icon: Tag,
    allow: ['admin', 'supervisor', 'agent'] as const,
  },
];

export default function SettingsLayout() {
  const role = useAuthStore((s) => s.user?.role);

  const visibleTabs = TABS.filter((t) => t.allow === null || t.allow.includes(role as never));

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-semibold tracking-tight text-slate-900">Configuración</h1>
        <p className="text-sm text-slate-500 mt-1">
          Ajustes de tu cuenta y administración del equipo.
        </p>
      </div>

      <div className="flex flex-col lg:flex-row gap-6">
        <nav className="lg:w-56 shrink-0">
          <ul className="space-y-0.5">
            {visibleTabs.map((tab) => (
              <li key={tab.to}>
                <NavLink
                  to={tab.to}
                  className={({ isActive }) =>
                    `w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm transition ${
                      isActive
                        ? 'bg-slate-900 text-white'
                        : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900'
                    }`
                  }
                >
                  <tab.icon size={16} />
                  {tab.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <div className="flex-1 min-w-0">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
